// Public contact page. Stripe underwriting expects a clear contact route.

export default function Contact(): JSX.Element {
  return (
    <article className="legal-page">
      <h1>Contact SubsWall</h1>
      <p className="legal-meta">
        Effective date: 2026-05-30 · Last updated: 2026-05-30
      </p>

      <p>
        SubsWall is operated by <strong>Dr. Gotthilf LLC</strong>, a Wyoming
        limited liability company.
      </p>

      <h2>Mailing address</h2>
      <p>
        Dr. Gotthilf LLC<br />
        30 N Gould St Ste R<br />
        Sheridan, WY 82801<br />
        United States
      </p>

      <h2>Email</h2>
      <ul>
        <li>
          <strong>Support</strong> (accounts, payouts, donations, general
          questions):{" "}
          <a href="mailto:support@subswall.com">support@subswall.com</a>
        </li>
        <li>
          <strong>Privacy</strong> (GDPR, CCPA, data-subject requests):{" "}
          <a href="mailto:privacy@subswall.com">privacy@subswall.com</a>
        </li>
        <li>
          <strong>Abuse</strong> (policy violations, fraud reports,
          child-safety):{" "}
          <a href="mailto:abuse@subswall.com">abuse@subswall.com</a>
        </li>
      </ul>

      <h2>Community</h2>
      <p>
        Discord:{" "}
        <a
          href="https://discord.gg/SubsWall"
          target="_blank"
          rel="noopener noreferrer"
        >
          discord.gg/SubsWall
        </a>
      </p>

      <h2>Response time</h2>
      <p>
        We respond to support and privacy email within{" "}
        <strong>48 hours on business days</strong> (Monday-Friday, Madrid
        time). Abuse and child-safety reports are triaged the same day they
        are received.
      </p>

      <h2>Press</h2>
      <p>
        Press and partnership inquiries: please use{" "}
        <a href="mailto:support@subswall.com">support@subswall.com</a>{" "}
        with the word <strong>PRESS</strong> in the subject line.
      </p>
    </article>
  );
}
